import React, {useEffect, useMemo} from "react";
import {useCheckPointList} from "~/apps/packages/auto-visits/hooks";
import {LoadingSelect, LoadingSelectProps} from "~/apps/packages/auto-visits/components/AutoVisitForm/LoadingSelect";
import {compareByField, distinctByField} from "~/apps/packages/auto-visits/utils";
import {CheckPoint} from "~/apps/packages/auto-visits/queries";


type Value = CheckPoint;


export type CheckpointSelectProps = Omit<LoadingSelectProps, "onChange"> & {
    autoVisitId?: string
    autoVisitDate?: Date
    carrierId: string
    cargoIds: string[]
    timeslotId: string
    value?: Value
    onChange?: (value: Value) => any
    additionalOptions?: Value[]
}


export const CheckpointSelect = (props: CheckpointSelectProps) => {
    const {
        carrierId,
        cargoIds,
        timeslotId,
        value,
        onChange,
        additionalOptions,
        autoVisitId,
        autoVisitDate,
        ...other
    } = props;

    const {data, loading} = useCheckPointList({
        cargoIds,
        carrierId,
        timeslotId,
        autoVisitId,
        autoVisitDate,
    });

    const availableValues = useMemo(() => {
        const availableValues: Value[] = [].concat(data).concat(additionalOptions).filter(Boolean);
        return distinctByField(availableValues, "ID").sort(compareByField("Name"));
    }, [data, additionalOptions]);

    const isValid = useMemo(() => {
        return loading || !value || availableValues.find(item => item.ID == value.ID)
    }, [loading, value, availableValues]);

    const handleChange = (e) => {
        const value = availableValues.find(item => item.ID == e.target.value);
        onChange && onChange(value);
    }

    useEffect(() => {
        if (!isValid) {
            onChange && onChange(null);
        }
    }, [isValid])

    return (
        <LoadingSelect
            label="КПП"
            {...other as LoadingSelectProps}
            value={value ? value.ID : ""}
            onChange={handleChange}
            loading={loading}
            options={[].concat(availableValues?.map(checkpoint => ({
                value: checkpoint.ID,
                title: checkpoint.Name
            })))}
            empty="Нет доступных кпп"
        />
    )
}